/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type ItemPreviews_viewer$ref = any;
export type ItemPreviews_viewer = {
    readonly isVisuallySimilarEnabled: boolean | null;
    readonly " $refType": ItemPreviews_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "ItemPreviews_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": "isVisuallySimilarEnabled",
            "name": "isEnabledByLocale",
            "args": [
                {
                    "kind": "Literal",
                    "name": "featureName",
                    "value": "VISUALLY_SIMILAR"
                }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"VISUALLY_SIMILAR\")"
        }
    ]
} as any);
(node as any).hash = '1e6484c7589bb1db209abc37afbaf16a';
export default node;
